import * as requestFromServer from "./LevelSectionsCrud";
import { callTypes, levelSectionSlice } from "./LevelSectionsSlice";

const {actions} = levelSectionSlice;

export const getLevelSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getLevelSections(queryParams)
    .then(response => {
      dispatch(actions.levelSectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllLevelSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllLevelSections(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getCourses = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getCourses()
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getLevelSection = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewLevelSection()
    .then(response => {
      dispatch(actions.levelSectionFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getLevelSection(id)
    .then(response => {
      dispatch(actions.levelSectionFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveLevelSection = section => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveLevelSection(section)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteLevelSections = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteLevelSections(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanLevelSectionsState = () => dispatch => {
  dispatch(actions.levelSectionsStateCleaned());
}